export default "__VITE_ASSET__CNSNVSC8__"